import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_RESTAURANT_STATUS, {

      pathParams: {
        restaurantId: id,
      },
    })
  },

  method: 'PATCH',

  format(payload) {
    const { status } = payload || {}
    return {
      status
    }
  },

  parse(raw = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to update restaurant status',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Statut du restaurant mis à jour',
      data: raw.data,
    }
  },
}
